import React from 'react';
import { useDemoBooking } from '../context/DemoBookingContext';

// Vertical tab pinned to the right edge of the viewport on every page. At rest
// it is a slim, slightly faded tab with small text; hover or keyboard focus
// grows it to full size. Touch screens simply keep the slim, tappable tab.
// Rendered by DemoBookingProvider, which wraps the whole site.
const FloatingDemoButton = ({ hidden }) => {
  const { openDemoBooking } = useDemoBooking();
  if (hidden) return null;

  return (
    <button
      type="button"
      onClick={openDemoBooking}
      title="Book a guided product demo"
      aria-label="Book a guided demo"
      className="cursor-pointer fixed right-0 top-1/2 z-40 -translate-y-1/2 rounded-l-lg bg-blue-600 px-1.5 py-3 text-xs font-semibold text-white opacity-75 shadow-md transition-all duration-200 hover:bg-blue-700 hover:px-3 hover:py-4 hover:text-sm hover:opacity-100 hover:shadow-lg focus:outline-none focus-visible:bg-blue-700 focus-visible:px-3 focus-visible:py-4 focus-visible:text-sm focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-blue-300 motion-reduce:transition-none print:hidden"
      style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
    >
      Book a guided demo
    </button>
  );
};

export default FloatingDemoButton;
